import uiRouter from "@uirouter/angularjs/lib-esm";
import "angular-formly";

import { config as routeConfig } from "./routes";
import { default as server } from "./server/index";
import { default as pagesProfile } from "./pages/profile/changePassword/index";
import AuthService, {
  default as authService,
} from "./authorization/authService";
import { default as genericNgIf } from "./authorization/directives/genericNgIfDirective";

import selectUserFormlyType from "./ui-formly/types/selectUser";

import {
  userProfileApiKeyPageComponentOptions,
  vsComponentName as userProfileApiKeyPageComponentName,
} from "./pages/profile/apiKeys";

import {
  vsComponentName as userDetailComponentName,
  userDetailComponentOptions,
  userDetailTabsServiceConfig,
  vsServiceName as UserDetailTabsServiceServiceName,
  UserDetailTabsServiceProvider,
} from "./pages/user";

import {
  vsComponentName as userDetailRolesComponentName,
  userDetailRolesComponentOptions,
} from "./pages/user/roles";

import { userObjectConfig } from "./config/user";
import { moduleName as recordsModuleName } from "../records";
import angular from "angular";
import { roleObjectConfig } from "./config/roles";
import {
  roleDetailComponentOptions,
  vsComponentName as roleDetailComponentName,
  RoleDetailTabsServiceProvider,
  vsServiceName as RoleDetailTabsServiceProviderName,
} from "./pages/role";
import {
  roleDetailPermissionsComponentOptions,
  vsComponentName as roleDetailPermissionsComponentName,
  roleDetailPermissionsComponentConfig,
} from "./pages/role/permissions";
import {
  roleDetailUserComponentOptions,
  vsComponentName as roleDetailUsersComponentName,
  roleDetailUsersComponentConfig,
} from "./pages/role/users";
import {
  roleDetailUserEditComponentOptions,
  vsComponentName as roleDetailUsersEditComponentName,
} from "./pages/role/users/edit";
import { apiKeyConfig } from "./config/apiKey";

import { vsBootstrapModuleName } from "../application/names";
import { permissionObjectConfig } from "./config/permissions";
import { userRolePermissionObjectConfig } from "./config/userRolePermission";

var mod = angular
  .module("SlotTrak.User", [
    "SlotTrak.UI",
    "SlotTrak.Utils",
    uiRouter,
    recordsModuleName,
    vsBootstrapModuleName,
  ])
  .config(routeConfig)
  .config(selectUserFormlyType)
  .config(userObjectConfig)
  .config(roleObjectConfig)
  .config(permissionObjectConfig)
  .config(userRolePermissionObjectConfig)
  .config(apiKeyConfig)
  .factory(server.vsName, server)
  .service(authService.vsName, authService)
  .directive("userProfilePage", pagesProfile)
  .directive(
    "ifHasPermissions",
    genericNgIf("ifHasPermissions", [
      authService.vsName,
      function (auth: AuthService) {
        return auth.hasPermissions;
      },
    ])
  )
  .directive(
    "ifHasAnyPermissions",
    genericNgIf("ifHasAnyPermissions", [
      authService.vsName,
      function (auth: AuthService) {
        return auth.hasAnyPermissions;
      },
    ])
  )
  .directive(
    "ifHasRoles",
    genericNgIf("ifHasRoles", [
      authService.vsName,
      function (auth: AuthService) {
        return auth.hasRoles;
      },
    ])
  )
  .component(
    userProfileApiKeyPageComponentName,
    userProfileApiKeyPageComponentOptions
  )
  .component(userDetailComponentName, userDetailComponentOptions)
  .provider(UserDetailTabsServiceServiceName, UserDetailTabsServiceProvider)
  .config(userDetailTabsServiceConfig)
  .component(userDetailRolesComponentName, userDetailRolesComponentOptions)
  .component(roleDetailComponentName, roleDetailComponentOptions)
  .provider(RoleDetailTabsServiceProviderName, RoleDetailTabsServiceProvider)
  .config(roleDetailPermissionsComponentConfig)
  .component(
    roleDetailPermissionsComponentName,
    roleDetailPermissionsComponentOptions
  )
  .component(roleDetailUsersComponentName, roleDetailUserComponentOptions)
  .config(roleDetailUsersComponentConfig)
  .component(
    roleDetailUsersEditComponentName,
    roleDetailUserEditComponentOptions
  );

export default mod.name;
